import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { Route, Link } from "react-router-dom";

import HccCalCalculation from './HccCalCalculation';
import HccCalIntro from './HccCalIntro';
import LDEval from './LDevaluation';
import "../../assets/css/App.css";
import Background from "../../assets/images/BG1.jpg";
import Header1 from '../public';


const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;

var sectionStyle = {
  width: "100%",

// makesure here is String确保这里是一个字符串，以下是es6写法
  backgroundImage: `url(${Background})`,
  backgroundColor:'rgba(255,178,178,0.2)',
};

class HCC extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            <div className="hcc"> 
            <Header1></Header1> 
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{background: '#fff' }}>
              <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['0']}
                    defaultOpenKeys={['sub3']}
                    style={{ height: '100%' }}
                  >
                    <SubMenu key="sub3" title={<span><Icon type="user" />Lipiodol</span>}>
                      <Menu.Item key="1"><Link to="/hcc-ld-introduction">Introduction</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/hcc-ld-evaluation">Evaluation</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub4" title={<span><Icon type="user" />Prediction</span>}>
                      <Menu.Item key="5"><Link to="/hcc-cal-introduction">Introduction</Link></Menu.Item>
                      <Menu.Item key="6"><Link to="/hcc-cal-calculation">Calculation</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                <Content>
                <div style={{background: `url(${Background}) no-repeat top center`,height:300,width: "100%",backgroundSize: "cover",}}>
                <div style={{textAlign:"center",color:"#fff"}}>
                <br></br><br></br><br></br>
                <txt style={{fontSize:50,fontWeight:'bold', color: '#0f3b63' }}>Extending our knowledge through clinical practice</txt><br></br>
                  <txt style={{fontSize:42,fontWeight:'bold', color: '#0f3b63' }}>Hepatocellular Carcinoma Module</txt>
                  </div>
                </div >
      
                
                
               

      
                  <div style={{paddingLeft:100,paddingRight:80}}>
                  <br></br>
                  <br></br>
                  <txt style={{fontSize:24}}>

                  <txt style={{fontWeight:'bold',}}>The Hepatocellular Carcinoma Module</txt> is designed for clinicians working on transcatheter arterial chemoembolization (TACE) therapy. The functions in this module can provide quantitative preoperative and postoperative clinical efficacy evaluation of TACE for patients with hepatocellular carcinoma. 
                  <br></br><br></br>The two main functions in this module are <txt style={{fontWeight:'bold',}}> <Link to="/hcc-ld-introduction">postoperative lipiodol deposition (LD) evaluation</Link></txt> and <txt style={{fontWeight:'bold',}}><Link to="/hcc-cal-introduction">first TACE efficacy prediction</Link>.</txt>
                  </txt>
                  </div>
                  
         
                  </Content>
                
              </Layout>
              </Content>
            </div>
        )
    }
}
export default HCC;